@if (tabService.tabsLoading() || tabs().length === 0) {
  <div class="flex h-full flex-col items-center justify-center gap-y-2 px-4 md:px-8 lg:px-16">
    <div class="flex max-w-3xl flex-col items-center gap-6">
      @if (tabService.tabsLoading()) {
        <!-- Loading tabs -->
        <p class="text-center">
          {{ 'chat.loading' | transloco }}
        </p>
      } @else {
        <app-welcome-screen [user]="authService.currentUser()"></app-welcome-screen>
      }
    </div>
  </div>
} @else {
  @for (tab of tabs(); track tab._id) {
    <!-- All tabs -->
    <div [ngClass]="{ 'pointer-events-none invisible z-[-1] opacity-0': tab._id !== activeTab()?._id }">
      <app-chat-tab
        [tab]="tab"
        [isPolling]="tab.isPolling"
        [vehicle]="tab.vehicle"
        class="absolute inset-0 overflow-y-auto"
        [ngClass]="{ 'z-10': tab._id === tabService.activeTab()?._id }" />
    </div>
  }
}
